import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LocalStorageService } from "angular-2-local-storage";
import { WindowRefService } from "./window.service";

@Injectable()
export class ApiService {
    private apiConfig: any;
    private config: any;
    private _window: any;

    constructor(
        windowRef: WindowRefService,
        private http: HttpClient,
        private localStorageService: LocalStorageService,
    ) {
        this._window = windowRef.nativeWindow;
        this.apiConfig = {
            _options: {
                headers: new HttpHeaders({ Authorization: 'Bearer ' + this.localStorageService.get('access_token') })
            },
            config: this._window.ApiConfig.url + 'config',
            register: this._window.ApiConfig.url + 'register',
            registerWithBusiness: this._window.ApiConfig.url + 'signup/business',
            addBusiness: this._window.ApiConfig.url + 'api/squarespace/business/add',
            token: this._window.ApiConfig.url + 'oauth/v2/token',
            username_check: this._window.ApiConfig.url + 'username_check',
            password_reset: this._window.ApiConfig.url + 'password_reset/start',
            password_set: this._window.ApiConfig.url + 'password_reset/confirm',
            password_taxapp: this._window.ApiConfig.url + 'taxapp/password_reset/confirm',
            getBusinesses: this._window.ApiConfig.url + 'api/user/current/portal',
            getCurrentUser: this._window.ApiConfig.url + 'api/user/current'
        };
    }

    resetHeaders() {
        this.apiConfig._options = {
            headers: new HttpHeaders({ Authorization: 'Bearer ' + this.localStorageService.get('access_token') })
        }
    }
    getConfig() {
        return new Promise((resolve, reject) => {
            if (this.config) {
                resolve(this.config);
            } else {
                this.loadConfig().then(resolve, reject)
            }
        });
    }
    loadConfig() {
        return new Promise((resolve, reject) => {
            this.http.get(this.apiConfig.config).toPromise()
                .then((response) => {
                    this.config = response;
                    resolve(this.config);
                }, reject);
        });
    }
    _post(url, data) {
        return this.http.post<any>(url, data, this.apiConfig._options).toPromise();
    }

    registerUser(data) {
        return this._post(this.apiConfig.register, {
            username: data.username,
            password: data.password,
            first_name: data.first_name,
            last_name: data.last_name,
            phone: data.phone,
            promo: data.promo,
            utm_campaign: data.utm_campaign,
            utm_content: data.utm_content,
            utm_medium: data.utm_medium,
            utm_source: data.utm_source,
            utm_term: data.utm_term,
            gclid: data.gclid
        })
    }
    registerWithBusiness(data) {
        return this._post(this.apiConfig.registerWithBusiness, {
            user: {
                username: data.username,
                password: data.password,
                first_name: data.first_name,
                last_name: data.last_name,
                phone: data.phone,
            },
            oauth_info: {
                client_id: this._window.ApiConfig.client_id,
                client_secret: this._window.ApiConfig.client_secret,
                grant_type: "password"
            },
            business: data.business,
            lead_source: "Squarespace",
        })
    }
    addBusiness(data) {
        return this._post(this.apiConfig.addBusiness, {
            address: data.address,
            business_owners: data.business_owners,
            name: data.name,
            business_type: data.business_type,
            form_state: data.form_state,
            industry: data.industry
        })
    }
    registerUserCheck(data) {
        return this._post(this.apiConfig.username_check, {
            username: data.username,
            password: data.password,
            first_name: data.first_name,
            last_name: data.last_name,
            phone: data.phone,
            promo: data.promo
        });
    }
    restorePassword(data) {
        return this._post(this.apiConfig.password_reset, data);
    }
    setNewPassword(data) {
        return this._post(this.apiConfig.password_set, data);
    }
    setNewTaxAppPassword(data) {
        return this.http.post<any>(this.apiConfig.password_taxapp, data, this.apiConfig._options).toPromise();
    }
    getBusinesses() {
        return this.http.get<any>(this.apiConfig.getBusinesses, this.apiConfig._options).toPromise();
    }
    getCurrentUser() {
        return this.http.get<any>(this.apiConfig.getCurrentUser, this.apiConfig._options).toPromise();
    }
    getToken(data) {
        return this.http.post<any>(this.apiConfig.token, {
            username: data.username,
            password: data.password,
            client_id: this._window.ApiConfig.client_id,
            client_secret: this._window.ApiConfig.client_secret,
            grant_type: "password"
        }).toPromise();
    }
}
